var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaturnLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 72,
    viewBox: "0 0 236 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1636_3221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5014 20.7561L20.063 41.2189V44.313L58.183 22.3239L55.5014 20.7561Z",
    fill: "url(#paint0_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3956 17.2506L20.063 34.2066V37.3008L52.1185 18.8183L49.3956 17.2506Z",
    fill: "url(#paint1_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3311 13.7432L20.063 27.1925V30.2867L46.0539 15.3109L43.3311 13.7432Z",
    fill: "url(#paint2_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6674 39.3623L33.8002 54.2968L36.4818 55.8645L59.6674 42.4565V39.3623Z",
    fill: "url(#paint3_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6686 25.3365L21.6723 47.2844L24.3539 48.8521L59.6686 28.4719V25.3365Z",
    fill: "url(#paint4_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.668 32.3494L27.7363 50.7906L30.4179 52.3583L59.668 35.4436V32.3494Z",
    fill: "url(#paint5_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6053 36.6811L28.3551 53.5546L31.7381 55.4936L57.6053 40.5591V36.6811Z",
    fill: "url(#paint6_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8851 13L18 24.5103V28.3883L41.2681 14.939L37.8851 13Z",
    fill: "url(#paint7_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9497 16.5074L18 31.4831V35.4024L47.3326 18.4464L43.9497 16.5074Z",
    fill: "url(#paint8_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0555 20.0129L18 38.4954V42.4146L53.3972 21.9519L50.0555 20.0129Z",
    fill: "url(#paint9_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6053 24.3866L56.1201 23.5203L18 45.5094V47.5722L19.5677 48.4798L57.6053 26.5319V24.3866Z",
    fill: "url(#paint10_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6056 29.6682L22.2909 50.0484L25.6739 51.9874L57.6056 33.5462V29.6682Z",
    fill: "url(#paint11_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6047 43.6539L34.4191 57.0619L37.802 59.0009L57.6047 47.5731V43.6539Z",
    fill: "url(#paint12_linear_1636_3221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9195 45.7732C89.1732 45.7732 91.6753 43.3221 91.6753 40.2581C91.6753 32.3755 80.8883 36.08 80.8883 30.7599C80.8883 29.1444 82.0838 27.6125 84.8361 27.6125C87.4773 27.6125 88.9508 28.9773 88.9508 31.2056H91.2583C91.2583 27.1668 87.8109 25.5513 84.8639 25.5513C80.9439 25.5513 78.6364 27.9746 78.6364 30.7599C78.6364 38.559 89.3956 34.2974 89.3956 40.3974C89.3956 42.4307 87.5607 43.6842 85.0029 43.6842C82.056 43.6842 80.2211 41.8737 80.2211 39.6175H77.9692C77.9692 43.2385 81.0551 45.7732 84.9195 45.7732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.442 45.4111H116.805L109.632 25.9134H106.435L99.1787 45.4111H101.542L103.238 40.7874H112.746L114.442 45.4111ZM103.238 40.7874L107.908 27.9746H108.075L112.746 40.7874H103.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.037 45.4111H130.289V27.9746H135.961V25.9134H122.366V27.9746H128.037V45.4111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.109 45.7732C156.724 45.7732 159.365 42.7928 159.365 38.3919V25.9134H157.141V38.3641C157.141 41.623 155.389 43.6842 152.109 43.6842C148.828 43.6842 147.104 41.623 147.104 38.3919V25.9134H144.852V38.4198C144.852 42.8485 147.438 45.7732 152.109 45.7732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.211 45.4111H172.463V37.5284H175.744L180.609 45.4111H183.334L178.107 37.3335C181.137 36.7764 182.722 34.4924 182.722 31.5956C182.722 28.1974 180.359 25.9134 176.383 25.9134H170.211V45.4111ZM172.463 35.523V27.9189H176.244C178.997 27.9189 180.387 29.5622 180.387 31.6234C180.387 34.186 178.663 35.523 176.383 35.523H172.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.795 45.4111H195.047V27.9746H195.213L203.887 45.4111H207.668V25.9134H205.444V43.3499H205.278L196.492 25.9134H192.795V45.4111Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1636_3221",
    x1: 25.3754,
    y1: 39.6915,
    x2: 57.6912,
    y2: 21.0369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0543568,
    stopColor: "#0090FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1636_3221",
    x1: 22.3408,
    y1: 34.4358,
    x2: 54.6566,
    y2: 15.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0543568,
    stopColor: "#0090FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1636_3221",
    x1: 19.3063,
    y1: 29.1784,
    x2: 51.6221,
    y2: 10.5238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0543568,
    stopColor: "#0090FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1636_3221",
    x1: 34.4766,
    y1: 55.4624,
    x2: 66.7923,
    y2: 36.8078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0543568,
    stopColor: "#0090FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1636_3221",
    x1: 28.4102,
    y1: 44.9492,
    x2: 60.726,
    y2: 26.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0543568,
    stopColor: "#0090FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1636_3221",
    x1: 31.4442,
    y1: 50.2055,
    x2: 63.7599,
    y2: 31.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0543568,
    stopColor: "#0090FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1636_3221",
    x1: 53.2136,
    y1: 40.2914,
    x2: 20.5251,
    y2: 61.8991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1636_3221",
    x1: 36.579,
    y1: 15.1258,
    x2: 3.89046,
    y2: 36.7334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1636_3221",
    x1: 39.9199,
    y1: 20.1807,
    x2: 7.23141,
    y2: 41.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1636_3221",
    x1: 43.2608,
    y1: 25.2337,
    x2: 10.5723,
    y2: 46.8413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1636_3221",
    x1: 46.5659,
    y1: 30.2344,
    x2: 13.8774,
    y2: 51.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#23AEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1636_3221",
    x1: 49.8731,
    y1: 35.2378,
    x2: 17.1845,
    y2: 56.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1636_3221",
    x1: 56.5537,
    y1: 45.346,
    x2: 23.8652,
    y2: 66.9536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1636_3221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 46,
    fill: "white",
    transform: "translate(18 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturnLogo);
export default __webpack_public_path__ + "static/media/saturn-logo.29f6604cec2eb9f94f5f4fa144a21430.svg";
export { ForwardRef as ReactComponent };